import { collection, doc, setDoc, getDocs } from 'firebase/firestore';
import { db } from './firebase-config';
import {
    INSTRUCTION_SUGGESTIONS,
    LANGUAGES,
    DEFAULT_FILTERS,
    USER_SETTINGS,
    USER_DEFAULT_FILTERS,
    ADDITIONAL_SETTINGS,
    BRANDS,
    OUTPUT_LANGUAGES,
    TARGET_COUNTRIES,
    USER_SIGNATURES,
} from 'utils/config/constants/controllerNames';
import { IS_EMULATOR_MODE } from '../constants';

const DEFAULT_TARGET_COUNTRIES = [
    { country_code: 'be', title: 'Belgium' },
    { country_code: 'ca', title: 'Canada' },
    { country_code: 'ch', title: 'Switzerland' },
    { country_code: 'cz', title: 'Czechia' },
    { country_code: 'hu', title: 'Hungary' },
    { country_code: 'in', title: 'India' },
    { country_code: 'it', title: 'Italy' },
    { country_code: 'jp', title: 'Japan' },
    { country_code: 'nl', title: 'Netherlands' },
    { country_code: 'ro', title: 'Romania' },
    { country_code: 'uk', title: 'United Kingdom' },
];

const DEFAULT_OUTPUT_LANGUAGES = [
    {
        name: 'Netherlands - NL',
        country: 'Netherlands',
        country_code: 'nl',
        framework_id: '',
        id: 7,
        language_code: 'nl',
        language_name: 'Dutch',
    },
    {
        name: 'Netherlands - EN',
        country: 'Netherlands',
        country_code: 'nl',
        framework_id: '',
        id: 8,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Switzerland - DE',
        country: 'Switzerland',
        country_code: 'ch',
        framework_id: '',
        id: 9,
        language_code: 'de',
        language_name: 'German',
    },
    {
        name: 'Switzerland - EN',
        country: 'Switzerland',
        country_code: 'ch',
        framework_id: '',
        id: 10,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Switzerland - FR',
        country: 'Switzerland',
        country_code: 'ch',
        framework_id: '',
        id: 11,
        language_code: 'fr',
        language_name: 'French',
    },
    {
        name: 'Italy - IT',
        country: 'Italy',
        country_code: 'it',
        framework_id: 'e3b8de78-0a61-4f96-a4da-8ff02aa340b8',
        id: 17,
        language_code: 'it',
        language_name: 'Italian',
    },
    {
        name: 'Italy - EN',
        country: 'Italy',
        country_code: 'it',
        framework_id: 'e3b8de78-0a61-4f96-a4da-8ff02aa340b8',
        id: 18,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Canada - FR',
        country: 'Canada',
        country_code: 'ca',
        framework_id: '',
        id: 21,
        language_code: 'fr',
        language_name: 'French',
    },
    {
        name: 'Canada - EN',
        country: 'Canada',
        country_code: 'ca',
        framework_id: '',
        id: 22,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Switzerland - IT',
        country: 'Switzerland',
        country_code: 'ch',
        framework_id: '',
        id: 23,
        language_code: 'it',
        language_name: 'Italian',
    },
    {
        name: 'India - EN',
        country: 'India',
        country_code: 'in',
        framework_id: '',
        id: 30,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Belgium - FR',
        country: 'Belgium',
        country_code: 'be',
        framework_id: '',
        id: 31,
        language_code: 'fr',
        language_name: 'French',
    },
    {
        name: 'Belgium - NL',
        country: 'Belgium',
        country_code: 'be',
        framework_id: '',
        id: 32,
        language_code: 'nl',
        language_name: 'Dutch',
    },
    {
        name: 'Belgium - EN',
        country: 'Belgium',
        country_code: 'be',
        framework_id: '',
        id: 33,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Romania - EN',
        country: 'Romania',
        country_code: 'ro',
        framework_id: '',
        id: 34,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Hungary - EN',
        country: 'Hungary',
        country_code: 'hu',
        framework_id: '',
        id: 35,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Hungary - HU',
        country: 'Hungary',
        country_code: 'hu',
        framework_id: '',
        id: 36,
        language_code: 'hu',
        language_name: 'Hungarian',
    },
    {
        name: 'Romania - RO',
        country: 'Romania',
        country_code: 'ro',
        framework_id: '',
        id: 37,
        language_code: 'ro',
        language_name: 'Romance',
    },
    {
        name: 'Czechia - CS',
        country: 'Czechia',
        country_code: 'cz',
        framework_id: '',
        id: 39,
        language_code: 'cs',
        language_name: 'Czech',
    },
    {
        name: 'Czechia - EN',
        country: 'Czechia',
        country_code: 'cz',
        framework_id: '',
        id: 40,
        language_code: 'en',
        language_name: 'English',
    },
    {
        name: 'Japan - JA',
        country: 'Japan',
        country_code: 'jp',
        framework_id: '',
        id: 55,
        language_code: 'ja',
        language_name: 'Japanese',
    },
    {
        name: 'United Kingdom - EN',
        country: 'United Kingdom',
        country_code: 'uk',
        framework_id: '',
        id: 35,
        language_code: 'en',
        language_name: 'English',
    },
];

const DEFAULT_BRANDS = [
    { key: 'yacht', name: 'YACHT', countries: [] },
    { key: 'randstad', name: 'randstad', countries: ['jp'] },
    { key: 'spherion', name: 'SPHERION', countries: [] },
    { key: 'operational', name: 'Operational', countries: ['in'] },
    { key: 'randstad_digital', name: 'Randstad Digital', countries: [] },
    { key: 'twago', name: 'Twago', countries: [] },
    { key: 'randstad-sourceright', name: 'Randstad Sourceright', countries: [] },
    { key: 'gulp', name: 'GULP', countries: [] },
    { key: 'tempo_team', name: 'Tempo Team', countries: ['be', 'nl'] },
    { key: 'randstad-risesmart', name: 'Randstad Risesmart', countries: [] },
    { key: 'expectra', name: 'Expectra', countries: [] },
    {
        key: 'randstad',
        name: 'Randstad',
        countries: ['ca', 'nl', 'ch', 'it', 'ja', 'be', 'ro', 'hu'],
    },
    { key: 'monster', name: 'Monster', countries: [] },
    { key: 'appel-medical', name: 'Appel Medical', countries: [] },
    { key: 'professionals', name: 'Professionals', countries: ['in'] },
];

const DEFAULT_USER_SIGNATURES = [
    {
        user_id: 'dummy-uid-123',
        nl_en: 'English version of the signature',
        nl_nl: 'Dutch version of the signature',
    },
];

const DEFAULT_ADDITIONAL_SETTINGS = {
    ANONYMIZED: {
        yes: 'Remove any type of information that reveals the identity of the client from the job post. Remove all names like client name, company name, recruiter name, team name, email address, ...). Leave placeholders for any information that reveal the identity of the author.',
        no: 'No',
    },
    FORMALITY_MARKS: [
        {
            id: 'highly_informal',
            value: 1,
            label: 'Highly informal',
            prompt: "Write in a super casual and relaxed language. use emojis or jokes to make it highly informal. If applicable to the language use the informal 'you' (e.g. 'du' instead of 'sie' in German).",
        },
        {
            id: 'informal',
            value: 3,
            label: 'Informal',
            prompt: "Write in casual and informal tone with friendly and laidback vibes. If applicable to the language use the informal 'you' (e.g. 'du' instead of 'sie' in German).",
        },
        {
            id: 'formal',
            value: 6,
            label: 'Formal',
            prompt: "Use formal and professional tone but incorporate some engaging or descriptive elements to attract candidates. If applicable to the language use the formal 'you' (e.g. 'sie' instead of 'du' in German) ",
        },
        {
            id: 'highly_formal',
            value: 9,
            label: 'Highly formal',
            prompt: "Use of highly formal language and structure throughout. Be detailed, precise, and follow a strict format in your presentation. Comply with the common standards observed in government organizations, or organizations with strict regulatory requirements, etc. If applicable to the language use the formal 'you' (e.g. 'sie' instead of 'du' in German).",
        },
    ],
    LENGTH_MARKS: [
        {
            id: 'summary',
            value: '70 - 100',
            label: 'Summary',
            prompt: 'Generate response in about 70 words.',
        },
        {
            id: 'concise',
            value: '100 - 150',
            label: 'Concise',
            prompt: 'Generate response in about 120  words.',
        },
        {
            id: 'short',
            value: '150 - 200',
            label: 'Short',
            prompt: 'Generate response in about 200 words.',
        },
        {
            id: 'long',
            value: '200 - 300',
            label: 'Long',
            prompt: 'Generate response in about 250 words.',
        },
        {
            id: 'elaborate',
            value: '300 - 500',
            label: 'Elaborate',
            prompt: 'Generate response in about 300 words.',
            additional: [{ in: 'Generate response more than 400 wwords.' }],
        },
    ],
    STRUCTURES: [
        {
            id: 1,
            label: 'Adjust the Heading Structure',
            value: 'Use appropriate headings and subheadings to organize the content.',
        },
        {
            id: 2,
            label: 'Modify the Paragraph Length',
            value: 'Optimize paragraph length for readability.',
        },
        {
            id: 3,
            label: 'Use Bulleted or Numbered Lists',
            value: 'Present key points, qualifications, or responsibilities using bullet points. Focus on readability.',
        },
        {
            id: 4,
            label: 'Incorporate Subsections',
            value: 'Divide the job post into sections or subsections based on different aspects of the job posting.',
        },
        {
            id: 5,
            label: 'Include Emoticons',
            value: 'Include emojis. Use them selectively and purposefully.',
        },
        {
            id: 6,
            label: 'Provide Clear Call-to-Action',
            value: 'End the job post with a clear and concise call-to-action. Instruct candidates on how to apply or next steps.',
        },
    ],
    TONES_OF_VOICE: [
        {
            id: 1,
            label: 'Professional and Formal',
            value: 'Communicate in a serious and business-like manner. Focusing on qualifications, experience, and professionalism.',
        },
        {
            id: 2,
            label: 'Friendly and Approachable',
            value: "Aim to create a welcoming environment. Use conversational language and a friendly tone to engage with candidates. Highlight the company's culture and values.",
        },
        {
            id: 3,
            label: 'Enthusiastic and Energetic',
            value: 'Aim to inspire excitement and passion in potential candidates. Showcase exciting opportunities associated with the role.',
        },
        {
            id: 4,
            label: 'Creative and Innovative',
            value: "Write with creativity in mind as well as imaginative language. Showcase the company's unique approach to empower creative individuals.",
        },
        {
            id: 5,
            label: 'Empowering and Motivational',
            value: 'Focus on empowering candidates, emphasizing their potential for growth. Aim for the impact you can make within the company. Use motivational language to inspire candidates to apply and develop their careers. ',
        },
        {
            id: 6,
            label: 'Informative and Educational',
            value: 'Write with straightforward and concise language. Provide detailed information about the role, responsibilities, and qualifications. Focusing on facts and specific requirements.',
        },
    ],
    URGENCY_MARKS: [
        {
            id: 'proactive',
            value: 1,
            label: 'Proactive',
            prompt: "Write in a way that creates a sense of urgency. Use phrases like 'Apply now' or 'Limited time offer'.",
        },
        {
            id: 'medium',
            value: 3,
            label: 'Medium',
            prompt: "This position is not important and needs to be filled at any time. From scale 1 to 4, where 1 means it is not urgent at all, and 4 means it is super urgent, this position's scale is 2.",
        },
        {
            id: 'high',
            value: 6,
            label: 'High',
            prompt: "This position is of high importance. Emphasize that employer is actively seeking qualified candidates. Demonstrate the employer aims to expedite the hiring process. From scale 1 to 4, where 1 means it is not urgent at all, and 4 means it is super urgent, this position's scale is 3.",
        },
        {
            id: 'urgent',
            value: 9,
            label: 'Urgent',
            prompt: "Suggest that the hiring process will move quickly. Encourage qualified candidates to apply immediately. Emphasize that candidate should be available immediately. From scale 1 to 4, where 1 means it is not urgent at all, and 4 means it is super urgent, this position's scale is 4.",
        },
    ],
};

const DEFAULT_USER_FILTERS_COLLECTION = [
    {
        user_id: 'dummy-uid-123',
        anonymized: 'yes',
        formality: 6,
        length: '175 - 250',
        structures: [1, 2],
        tone_of_voice: 1,
        urgency: 3,
    },
];

const DEFAULT_FILTERS_ITEMS = [
    {
        anonymized: 'yes',
        formality: 6,
        length: '175 - 250',
        structures: [1, 2],
        tone_of_voice: 1,
        urgency: 3,
    },
];

const DEFAULT_APP_LANGUAGES = [
    { key: 'en', title: 'English' },
    { key: 'cs', title: 'Čeština' },
    { key: 'nl', title: 'Nederlands' },
    { key: 'fr', title: 'Français' },
    { key: 'fr-CH', title: 'Français (Suisse)' },
    { key: 'de', title: 'Deutsch' },
    { key: 'de-CH', title: 'Deutsch (Schweiz)' },
    { key: 'hu', title: 'Magyar' },
    { key: 'it-IT', title: 'Italiano (Italia)' },
    { key: 'it-CH', title: 'Italiano (Svizzera)' },
    { key: 'ja', title: '日本語' },
    { key: 'ro', title: 'Română' },
    { key: 'es-ES', title: 'Español (España)' },
];

const DEFAULT_INSTRUCTION_SUGGESTIONS = [
    {
        title: 'Write in first-person (e.g. I am hiring...)',
        prompt: `Use first-person voice throughout the job description. For example, instead of saying "We are looking for a Java developer," say "I am hiring a Java developer."`,
    },
    {
        title: 'Write in first person plural ( e.g. We are hiring...)',
        prompt: `Use first-person plural voice throughout the job description. For example, instead of saying "I am hiring a Java developer," say "We are hiring a Java developer."`,
    },
    {
        title: "Address the candidate as second-person ( e.g. You'll receive competitive compensation...)",
        prompt: `Use the second-person voice ("you" and "your") throughout the job description to speak directly to the candidate. For example, instead of saying "We offer competitive compensation," say "You'll receive competitive compensation."`,
    },
    {
        title: 'Address the candidate as third-person ( e.g. The candidate will have the opportunity to.. They will receive competitive compensation...)',
        prompt: `Use third-person voice throughout the job description, focusing on the candidate (e.g., "The candidate will have the opportunity to..." or "They will receive competitive compensation...")`,
    },
];

export const initializeFirestoreData = async () => {
    try {
        if (IS_EMULATOR_MODE) {
            console.debug('Initializing firestore emulator data for local development...');
            // Create user settings
            const userSettingsSnapshot = await getDocs(collection(db, USER_SETTINGS));
            if (userSettingsSnapshot.empty) {
                const userSettingsRef = doc(collection(db, USER_SETTINGS));
                await setDoc(userSettingsRef, {
                    user_id: 'dummy-uid-123',
                    user_type: 'brand',
                    brand: 'randstad',
                    target_country: 'Netherlands',
                    target_country_code: 'nl',
                    output_language_title: 'Netherlands - EN',
                    output_language_code: 'en',
                });
            }

            // Create user signatures
            const userSignaturesSnapshot = await getDocs(collection(db, USER_SIGNATURES));
            if (userSignaturesSnapshot.empty) {
                const userSignaturesRef = collection(db, USER_SIGNATURES);
                for (const signature of DEFAULT_USER_SIGNATURES) {
                    const signatureRef = doc(userSignaturesRef);
                    await setDoc(signatureRef, signature);
                }
            }

            // Create user default filters with dummy data
            const userDefaultFiltersSnapshot = await getDocs(collection(db, USER_DEFAULT_FILTERS));
            if (userDefaultFiltersSnapshot.empty) {
                const userDefaultFiltersRef = collection(db, 'user_default_filters');
                for (const filter of DEFAULT_USER_FILTERS_COLLECTION) {
                    const filterRef = doc(userDefaultFiltersRef);
                    await setDoc(filterRef, filter);
                }
            }
        }

        console.debug('Initializing firestore data...');
        // Create target countries
        const targetCountriesSnapshot = await getDocs(collection(db, TARGET_COUNTRIES));
        if (targetCountriesSnapshot.empty) {
            const targetCountriesRef = collection(db, TARGET_COUNTRIES);
            // check if the country already exists
            for (const country of DEFAULT_TARGET_COUNTRIES) {
                if (
                    targetCountriesSnapshot.docs.some(
                        (doc) => doc.data().country_code === country.country_code,
                    )
                ) {
                    continue;
                }
                const countryRef = doc(targetCountriesRef);
                await setDoc(countryRef, country);
            }
        }

        // Create output languages
        const outputLanguagesSnapshot = await getDocs(collection(db, OUTPUT_LANGUAGES));
        if (outputLanguagesSnapshot.empty) {
            const outputLanguagesRef = collection(db, OUTPUT_LANGUAGES);
            for (const language of DEFAULT_OUTPUT_LANGUAGES) {
                const languageRef = doc(outputLanguagesRef);
                await setDoc(languageRef, language);
            }
        }

        // Create brands
        const brandsSnapshot = await getDocs(collection(db, BRANDS));
        if (brandsSnapshot.empty) {
            const brandsRef = collection(db, BRANDS);
            for (const brand of DEFAULT_BRANDS) {
                const brandRef = doc(brandsRef);
                await setDoc(brandRef, brand);
            }
        }

        // Create additional settings
        const additionalSettingsSnapshot = await getDocs(collection(db, ADDITIONAL_SETTINGS));
        if (additionalSettingsSnapshot.empty) {
            const additionalSettingsRef = doc(collection(db, ADDITIONAL_SETTINGS));
            await setDoc(additionalSettingsRef, DEFAULT_ADDITIONAL_SETTINGS);
        }

        // Create default filters with dummy data
        const defaultFiltersSnapshot = await getDocs(collection(db, DEFAULT_FILTERS));
        if (defaultFiltersSnapshot.empty) {
            const defaultFiltersRef = doc(collection(db, DEFAULT_FILTERS));
            await setDoc(defaultFiltersRef, {
                items: DEFAULT_FILTERS_ITEMS,
                document_id: defaultFiltersRef.id,
            });
        }

        // Create app languages with applanga data
        const defaultAppLanguages = await getDocs(collection(db, LANGUAGES));
        if (defaultAppLanguages.empty) {
            const appLanguagesRef = collection(db, LANGUAGES);
            for (const lang of DEFAULT_APP_LANGUAGES) {
                const languagesRef = doc(appLanguagesRef);
                await setDoc(languagesRef, lang);
            }
        }

        // Create default instruction suggestions
        const instructionSuggestionsSnapshot = await getDocs(
            collection(db, INSTRUCTION_SUGGESTIONS),
        );
        if (instructionSuggestionsSnapshot.empty) {
            const instructionSuggestionsRef = collection(db, INSTRUCTION_SUGGESTIONS);
            for (const suggestion of DEFAULT_INSTRUCTION_SUGGESTIONS) {
                const suggestionRef = doc(instructionSuggestionsRef);
                await setDoc(suggestionRef, suggestion);
            }
        }

        console.debug('Firestore data initialized successfully');
    } catch (error) {
        console.error('Error initializing firestore data:', error);
    }
};
